
export default {
  install(Vue) {
    Vue.prototype.$isEmail = email => {
      const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+\w$/;
      return regexp.test(email);
    };
  },
};
